import {
  IconInfo,
  IconPort,
  IconTerminal,
  IconVessel,
  type IconComponent
} from '@gat-ship/icons'

/** The sidebar tabs of the port detail modal. */
export const PORT_DETAIL_SECTIONS = [
  'details',
  'terminals',
  'berths',
  'anchorages'
] as const

export type PortDetailSection = (typeof PORT_DETAIL_SECTIONS)[number]

export interface PortDetailSidebarItem {
  key: PortDetailSection
  label: string
  icon: IconComponent
}

/**
 * Sidebar items for the port detail modal: Details, Terminals, Berths,
 * Anchorages.
 */
export function getPortDetailSidebarItems(): PortDetailSidebarItem[] {
  return [
    { key: 'details', label: 'Details', icon: IconInfo },
    { key: 'terminals', label: 'Terminals', icon: IconTerminal },
    { key: 'berths', label: 'Berths', icon: IconVessel },
    { key: 'anchorages', label: 'Anchorages', icon: IconPort }
  ]
}

/** Validate a raw query value into a known section, defaulting to `details`. */
export function toValidPortSection(value: string | null): PortDetailSection {
  return PORT_DETAIL_SECTIONS.includes(value as PortDetailSection)
    ? (value as PortDetailSection)
    : 'details'
}
